var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value-wrapper"},[_c('div',{staticClass:"value-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"value-data"},[_c('span',{staticClass:"value-value"},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"value-unit"},[_vm._v(" "+_vm._s(_vm.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }